<template>
<div class="" style="">
<!--
<div class="yo-text-bold yo-text-l white" style="background:#379EC2;padding:10px 20px;margin-bottom:10px;">
        
        Gentile Cliente,
<br />
informiamo che per attività di manutenzione sul sito, nei giorni 11 e 12 dicembre, non sarà possibile accedere per effettuare iscrizioni.
<br />
Biomedia srl

      </div>
-->

   <div class="row pad-in vpad yo-text-normal" style="background-color:#ffffff;" >
      
      <div class="col s12 m3 ">
         <div class="yo-align-center yo-bg-color-secondary white yo-text-m yo-text-uppercase yo-text-bold" style="margin-top:60px;padding:4px 0;"><router-link to="/evento-search/0" style="color:#fff;">Calendario completo</router-link></div>
         <calendar></calendar>
         <div class="yo-text-s yo-align-center" style="margin-top:6px;"><a class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s yo-text-bold" style="line-height:24px;" href="/gdpr/privacy_BVENT.pdf" target="_blank">Informativa Privacy</a></div>
      </div>
      <div class="col s12 m9" style="">

         <div class="yo-align-center yo-color-secondary yo-text-xl yo-text-bold">Convegni e Congressi</div>
         <el-carousel :interval="5000"   arrow="arrow" style="border:2px solid #fff;" :height="($teras.app.device=='mobile') ? parseInt(($teras.app.height>$teras.app.width ? 240 : $teras.app.height)/1.5)+'px' :'450px'" :indicator-position="($teras.app.device=='mobile') ? 'none' :''">
            <el-carousel-item v-for="item in eventislide" :key="item.id">
              <router-link :to="'/evento-home/'+item.id"><div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': 'url('+$teras.bventUrl+item.id+'/'+item.img+')'}"></div></router-link>
            </el-carousel-item>

<!--
            <el-carousel-item >
            <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/test-slide.png')})`}"></div>
            </el-carousel-item>

            <el-carousel-item >
            <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/slide.png')})`}"></div>
            </el-carousel-item>

            <el-carousel-item >
            <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/slide02.png')})`}">

            </div>
            </el-carousel-item>

            <el-carousel-item >
            <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/slide03.png')})`}">

            </div>
            </el-carousel-item>

            <el-carousel-item >
            <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/slide04.png')})`}">

            </div>
            </el-carousel-item>
-->
         </el-carousel>
      </div>
   </div>


  <a href="https://www.biomedia.net/webinar/"><img src="/nlweb/images/webinar_20200715.jpg" style="width:100%;max-width:1296px;margin:0 auto;display:block;"/></a>

  
   <div class="row yo-bg-color-primary" style="margin:20px 0;min-height:400px;overflow:hidden;" >

      <div class="catalogo-fad col s12 m3m yo-align-left white"  >

         <div class="header yo-bg-full yo-valign-center yo-align-center;" style="height:160px;margin:30px 10px;" :style="{'background-image': `url(${require('../assets/catalogo-fad.png')})`}">
            <div class="arnoprodisplay" style="">
               <div class="yo-text-xxxxl yo-align-center yo-text-bold" style="width:90%;">Catalogo</div>
               <div class="yo-text-xxl yo-align-right" style="width:70%;"> corsi FAD</div>
            </div>
         </div>

         


         <div class="left-menu" style="padding:40px;">
           <router-link to="/fad" class="yo-block white yo-align-left yo-text-xl" style="margin-bottom:40px; text-transform: uppercase;">» visualizza tutti i corsi</router-link>

            <a href="/1699-2/" class="yo-block white" style="margin-bottom:20px;">» Informazioni tecniche</a>
           <!-- <router-link class="yo-block white" style="margin-bottom:20px;" to="/">» Informazioni commerciali</router-link> -->
            <a class="yo-block white" style="margin-bottom:20px;" href="/archivio-fad">» Archivio catalogo FAD</a>
            <a href="/faq-partecipanti/" class="yo-block white" >» FAQ</a>
         </div>

      </div>

      <div class="col s12 m8m yo-align-center" style="padding-bottom:20px;" v-on:mouseenter="fadOver=!fadOver"  v-on:mouseleave="fadOver=!fadOver">

        
  <!--
    <div style="height:120px">
        <transition name="slide-top" v-on:leave="slidenext">
          <div v-if="show==1"   style="height:100px;width:100%;position:inline;border:1px solid red;">hello 1</div>
        </transition>

        <transition name="slide-top" v-on:leave="slidenext">
          <div v-if="show==3"  style="height:100px;width:100%;position:inline;border:1px solid red;">hello 2</div>
        </transition>
  </div>
  -->
         <div class="row " style="" >

            <div class="col s12 white yo-text-xl yo-align-center" style="padding-right:20px;line-height:50px;font-size: 70px;padding: 20px;line-height: 1;font-weight: 700;">
               Formazione a Distanza (FAD)
            </div>

            <div class="col s12 m6 yo-align-center" style="padding-right:20px;z-index:1001;position:relative;" >
            <div style="border:2px solid #fff;">
               <div class="yo-color-primary yo-text-bold" style="background:#fff;">AREA MEDICINA DI LABORATORIO<br />E ALTREE AREE</div>
               
               <div class="yo-bg-color-primary" style="border-bottom:2px solid #fff;height:16px;overflow:hidden;">&#160;</div>
               
               <img src="../assets/fad-medicina.png" style="width:100%;display:block;"/>
            </div>
            </div>

            <div class="col s12 m6 yo-align-center" style="padding-right:20px;z-index:1001;position:relative;" >
            <div style="border:2px solid #fff;">
               <div class="yo-color-primary yo-text-bold" style="background:#fff;">AREA PEDIATRIA E<br />NEONATOLOGIA</div>
               <div class="yo-bg-color-primary" style="border-bottom:2px solid #fff;height:16px;overflow:hidden;">&#160;</div>
               <img src="../assets/fad-pediatria.png" style="width:100%;display:block;"/>
            </div>
            </div>

            <!--
            <div class="col s12 " style="padding-right:20px;">
               <div class="white yo-text-l yo-align-center" style="line-height:40px;border-left:2px solid #fff;border-right:2px solid #fff;">in evidenza</div>
            </div>
            -->

            <div class="col s12 m6 yo-align-center" style="padding-right:20px;" >
            <div style="border:2px solid #fff;border-top:none;">
                <div style="height:352px" >
                  <!-- <transition name="slide-top" v-on:leave="slidenext"> -->
                  <slide-y-up-transition :duration="{enter: 600, leave: 600}" v-if="fadAltro.length>1">
                    <div v-show="show==1 " >
                    <div class="fad-evidenza yo-align-left white"  >
                      <div class="arrow-right"></div>
                      <div style="padding-left:30px;">
                        <div class="titolo yo-text-bold">{{fadAltro[0].titolo}}</div>
                        <div class="sottotitolo" v-html="fadAltro[0].respscientifico"></div>
                      </div>
                      <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                        <div class="col s4 offset-s4"><a  :href="fadAltro[0].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadAltro[0].crediti}} crediti ECM</a></div>
                        <div class="col s4"><a :href="fadAltro[0].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                      </div>
                    </div>

                    <div class="fad-evidenza yo-align-left white"  >
                      <div class="arrow-right"></div>
                      <div style="padding-left:30px;">
                        <div class="titolo yo-text-bold">{{fadAltro[1].titolo}}</div>
                        <div class="sottotitolo" v-html="fadAltro[1].respscientifico"></div>
                      </div>
                      <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                        <div class="col s4 offset-s4"><a  :href="fadAltro[1].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadAltro[1].crediti}} crediti ECM</a></div>
                        <div class="col s4"><a :href="fadAltro[1].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                      </div>
                     </div>
                    </div>
                  </slide-y-up-transition>
                  <!-- </transition> -->

                  <!-- <transition name="slide-top" v-on:leave="slidenext"> -->
                  <slide-y-up-transition   :duration="{enter: 600, leave: 600}" v-if="fadAltro.length>3">
                    <div v-show="show==2">
                    <div class="fad-evidenza yo-align-left white"  >
                      <div class="arrow-right"></div>
                      <div style="padding-left:30px;">
                        <div class="titolo yo-text-bold">{{fadAltro[2].titolo}}</div>
                        <div class="sottotitolo" v-html="fadAltro[2].respscientifico"></div>
                      </div>
                      <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                        <div class="col s4 offset-s4"><a  :href="fadAltro[2].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadAltro[2].crediti}} crediti ECM</a></div>
                        <div class="col s4"><a  :href="fadAltro[2].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                      </div>
                     </div>

                     <div class="fad-evidenza yo-align-left white"  >
                      <div class="arrow-right"></div>
                      <div style="padding-left:30px;">
                        <div class="titolo yo-text-bold">{{fadAltro[3].titolo}}</div>
                        <div class="sottotitolo" v-html="fadAltro[3].respscientifico"></div>
                      </div>
                      <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                        <div class="col s4 offset-s4"><a  :href="fadAltro[3].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadAltro[3].crediti}} crediti ECM</a></div>
                        <div class="col s4"><a :href="fadAltro[3].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                      </div>
                    </div>
                    </div>
                  </slide-y-up-transition>
                  <!-- </transition> -->

                </div>

               

               

            </div>
            </div>

            <div class="col s12 m6 yo-align-center" style="padding-right:20px;" >
            <div style="border:2px solid #fff;border-top:none;">
              <div style="height:352px">
                  <slide-y-up-transition v-if="fadPediatria.length>1" >
                    <div v-show="show==1">
                    
                        <div class="fad-evidenza yo-align-left white">
                            <div class="arrow-right"></div>
                            <div style="padding-left:30px;">
                              <div class="titolo yo-text-bold">{{fadPediatria[0].titolo}}</div>
                              <div class="sottotitolo" v-html="fadPediatria[0].respscientifico"></div>
                            </div>
                            <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                              <div class="col s4 offset-s4"><a  :href="fadPediatria[0].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadPediatria[0].crediti}} crediti ECM</a></div>
                              <div class="col s4"><a :href="fadPediatria[0].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                            </div>
                        </div>
                        
                        <div class="fad-evidenza yo-align-left white">
                            <div class="arrow-right"></div>
                            <div style="padding-left:30px;">
                              <div class="titolo yo-text-bold">{{fadPediatria[1].titolo}}</div>
                              <div class="sottotitolo" v-html="fadPediatria[1].respscientifico"></div>
                            </div>
                            <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                              <div class="col s4 offset-s4"><a  :href="fadPediatria[1].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadPediatria[1].crediti}} crediti ECM</a></div>
                              <div class="col s4"><a :href="fadPediatria[1].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                            </div>
                        </div>

                        

                    </div>
                  </slide-y-up-transition>

                  <slide-y-up-transition v-if="fadPediatria.length>3" >
                    <div v-show="show==2 ">
                    
                        <div class="fad-evidenza yo-align-left white">
                            <div class="arrow-right"></div>
                            <div style="padding-left:30px;">
                              <div class="titolo yo-text-bold">{{fadPediatria[2].titolo}}</div>
                              <div class="sottotitolo" v-html="fadPediatria[2].respscientifico"></div>
                            </div>
                            <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                              <div class="col s4 offset-s4"><a  :href="fadPediatria[2].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadPediatria[2].crediti}} crediti ECM</a></div>
                              <div class="col s4"><a :href="fadPediatria[2].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                            </div>
                        </div>

                        <div class="fad-evidenza yo-align-left white">
                            <div class="arrow-right"></div>
                            <div style="padding-left:30px;">
                              <div class="titolo yo-text-bold">{{fadPediatria[3].titolo}}</div>
                              <div class="sottotitolo" v-html="fadPediatria[3].respscientifico"></div>
                            </div>
                            <div class="row pad" style="margin-top:16px; margin-bottom:10px;padding-right:10px;">
                              <div class="col s4 offset-s4"><a  :href="fadPediatria[3].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">{{fadPediatria[3].crediti}} crediti ECM</a></div>
                              <div class="col s4"><a :href="fadPediatria[3].linkcomplete" class="yo-bg-color-secondary yo-block white yo-align-center yo-text-s" style="height:30px;line-height:30px;">Info & Iscrizioni</a></div>
                            </div>
                        </div>

                    </div>
                  </slide-y-up-transition>

                </div>



            
               

            </div>
            </div>



         </div>
      </div>
   </div>


   <!-- SEZIONE SEARCH -->
   <search ></search>

   <!-- SEZIONE INTERESSE O RANDOM -->
   <eventiInteresse :mylogin="true"></eventiInteresse>

   <!-- SEZIONE AREE -->
   <aree ></aree>

  
</div>
</template>

<script>
import { SlideYUpTransition } from 'vue2-transitions'

import calendar from '../components/Calendar'
import eventiInteresse from '../components/Eventi-interesse'
import aree from '../components/Aree'
import search from '../components/Evento-search-form'
export default {
  name: 'home',
  components: {
    calendar,
    eventiInteresse,
    aree
    ,search
    ,SlideYUpTransition
  },
  created () {

    window.location.href = "https://biomedia.net/ecm/webinar-res/";


    this.$teras.page.title = "BioMedia"
    this.$teras.page.sezione = "CORSI E CONVEGNI"

    setInterval(() => { 
         if(!this.fadOver)
          this.show++
         if(this.show==3)
            this.show=1
      }, 9000)
      
/*
    setInterval(() => { 
         this.fadRight++
         if(this.fadRight==4)
            this.fadRight=1
      }, 5000)
    */
  },
  data() {
    return {
      show: 1
      ,fadOver: false
      ,fadRight: 1
    }
  },
  methods:{
    fadRightNext(){
      console.log("fadRIght: "+this.fadRight)
      if(this.fadRight % 2 == 0){
        //console.log("PARI")

        setTimeout(() => { 
         this.fadRight++
         if(this.fadRight==4)
            this.fadRight=0
        }, 800)
      }

    },
    slidenext(){
      console.log("enter ")
      if(this.show % 2 == 0){
        

        setTimeout(() => { 
         this.show++
         if(this.show==4)
            this.show=0
        }, 800)






      }
    },
    shuffle(){
      console.log(this.$teras._nextevento)
      console.log(this.$teras.shuffle(this.$teras._nextevento))
      var ppp = this.$teras.shuffle(this.$teras._nextevento)
      this.$teras._nextevento = ppp
    }
  },
   computed: {
      eventislide: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            if(item.imgslidepubblicata==1)
               itemFilter.push({id:item.id,img:item.imgslide}) 
         }
         return itemFilter
      },
      fadAltro: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1 && this.$teras.findinset(2,item.macroarea))
               itemFilter.push(item) 
            //if(itemFilter.length>4)
              //break
         }
         return itemFilter.sort(this.$teras.compareValues('finisceil','desc'))
      },
      fadPediatria: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1 && this.$teras.findinset(1,item.macroarea))
               itemFilter.push(item) 
            //if(itemFilter.length>4)
              //break
         }
         return itemFilter.sort(this.$teras.compareValues('finisceil','desc'))
      }
   }
}
</script>


<style>
.slider {
  height: 300px;
}
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue